import React from 'react';
import CSSModules from 'react-css-modules';
import cn from 'classnames';
import MediaQuery from 'react-responsive';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { compose } from 'recompose';
import { connect } from 'react-redux';

import Icon from '../../Icon';
import { COMMON } from '../../../constants/strings';
import ClickableElement from '../../ClickableElement';
import { isFlagler } from '../../../constants/brandConfig';
import { BREAKPOINT, COLORS } from '../../../constants/styles';
import { isLoggedInSelector } from '../../../redux/auth/selectors';
import styles from './index.styl';

const BackButton = ({
  intl: { formatMessage },
  onBack,
  disabled,
  minWidth,
  className,
  title,
  isLoggedIn,
  hasTitle = true,
}) => (
  <MediaQuery minWidth={minWidth}>
    <ClickableElement
      className={className}
      styleName={cn('back', { disabled })}
      onClick={() => onBack()}
    >
      <Icon
        name={isFlagler && !isLoggedIn ? 'arrow-left' : 'back-healthboard'}
        size={24}
        style={{
          fill: COLORS.darkSlateBlue,
        }}
      />
      <span styleName="back__title">{hasTitle && formatMessage(title)}</span>
    </ClickableElement>
  </MediaQuery>
);

BackButton.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onBack: PropTypes.func,
  minWidth: PropTypes.number,
  title: PropTypes.shape({ id: PropTypes.string }),
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
  isLoggedIn: PropTypes.bool,
  hasTitle: PropTypes.bool,
};

BackButton.defaultProps = {
  className: '',
  onBack: () => {},
  title: COMMON.back,
  minWidth: BREAKPOINT,
};

const mapStateToProps = state => ({
  isLoggedIn: isLoggedInSelector(state),
});

export default compose(
  injectIntl,
  connect(mapStateToProps),
  CSSModules(styles, { allowMultiple: true }),
)(BackButton);



// WEBPACK FOOTER //
// ./src/components/common/BackButton/index.jsx